// Slow editorial marquee strip.
export const Marquee = ({ items, className = "" }) => {
  const loop = [...items, ...items];
  return (
    <div
      className={`relative overflow-hidden border-y border-hairline bg-champagne py-6 ${className}`}
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {loop.map((item, i) => (
          <span
            key={i}
            className="mx-8 flex items-center gap-8 font-serif text-2xl italic text-forest md:text-4xl"
          >
            {item}
            <span className="text-gold not-italic">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
